// =====================================================================
// Tsujimoto Market — In-Cart Shipping Estimator
// Вставить в самый низ файла assets/custom.js и нажать Save.
// Показывает реальную стоимость доставки на странице /cart до оплаты.
// Ничего не меняет в тарифах и ничего не дарит — только показывает.
// =====================================================================
(function () {
  function onCart() {
    // Works for /cart and localized prefixes like /ru/cart, /de/cart, /en-us/cart …
    return /(^|\/)cart\/?($|[?#])/.test(location.pathname) || !!document.querySelector('.cart-recap');
  }
  if (!onCart()) return;

  // --- стили (вставляются через JS) ---
  var css = '#tm-ship-est{margin:14px 0;padding:14px;border:1px solid #e3d3dc;border-radius:10px;background:#fdf8fb;font-size:14px}'
    + '#tm-ship-est .tm-ttl{font-weight:600;margin-bottom:8px}'
    + '#tm-ship-est select,#tm-ship-est input{width:100%;padding:8px;margin-top:6px;border:1px solid #cbb8c4;border-radius:6px;font-size:14px;box-sizing:border-box}'
    + '#tm-ship-est button.tm-go{margin-top:10px;width:100%;padding:9px;border:0;border-radius:6px;background:#7a0c3e;color:#fff;font-weight:600;cursor:pointer}'
    + '#tm-ship-est button.tm-go:disabled{opacity:.6;cursor:default}'
    + '#tm-ship-est .tm-res{margin-top:10px}'
    + '#tm-ship-est .tm-rate{display:flex;justify-content:space-between;padding:6px 0;border-top:1px dashed #e3d3dc}'
    + '#tm-ship-est .tm-msg{margin-top:8px;color:#7a0c3e}'
    + '#tm-ship-est .tm-note{margin-top:8px;font-size:12px;color:#7a6a72}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var COUNTRIES = [
    ["","— Select country —"],["AU","Australia"],["AT","Austria"],["BE","Belgium"],["BR","Brazil"],
    ["BN","Brunei"],["KH","Cambodia"],["CA","Canada"],["CN","China"],["HR","Croatia"],["CY","Cyprus"],
    ["CZ","Czechia"],["DK","Denmark"],["EG","Egypt"],["EE","Estonia"],["FI","Finland"],["FR","France"],
    ["DE","Germany"],["GR","Greece"],["HK","Hong Kong"],["HU","Hungary"],["IS","Iceland"],["IN","India"],
    ["ID","Indonesia"],["IE","Ireland"],["IL","Israel"],["IT","Italy"],["JP","Japan"],["JO","Jordan"],
    ["KZ","Kazakhstan"],["KW","Kuwait"],["LV","Latvia"],["LB","Lebanon"],["LT","Lithuania"],
    ["LU","Luxembourg"],["MO","Macau"],["MY","Malaysia"],["MV","Maldives"],["MT","Malta"],["MX","Mexico"],
    ["MN","Mongolia"],["NL","Netherlands"],["NZ","New Zealand"],["NO","Norway"],["OM","Oman"],
    ["PH","Philippines"],["PL","Poland"],["PT","Portugal"],["QA","Qatar"],["RO","Romania"],["RU","Russia"],
    ["SA","Saudi Arabia"],["SG","Singapore"],["SK","Slovakia"],["SI","Slovenia"],["KR","South Korea"],
    ["ES","Spain"],["LK","Sri Lanka"],["SE","Sweden"],["CH","Switzerland"],["TW","Taiwan"],["TH","Thailand"],
    ["TR","Turkiye"],["AE","United Arab Emirates"],["GB","United Kingdom"],["US","United States"],
    ["VN","Vietnam"]
  ];

  function fmt(p) {
    // Тарифы приходят в валюте магазина (JPY). Конвертируем в валюту страницы по курсу Shopify.
    var cur = (window.Shopify && Shopify.currency) || { active: 'JPY', rate: '1' };
    var rate = parseFloat(cur.rate) || 1;
    var amt = parseFloat(p) * rate;
    var sym = { JPY:'¥', USD:'$', EUR:'€', GBP:'£', AUD:'A$', CAD:'C$', SGD:'S$', CHF:'CHF ', CNY:'¥', HKD:'HK$', TWD:'NT$', KRW:'₩', AED:'AED ' };
    var zeroDecimal = { JPY:1, KRW:1, VND:1 };
    var n = zeroDecimal[cur.active]
      ? Math.round(amt).toLocaleString('en-US')
      : amt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return sym[cur.active] ? sym[cur.active] + n : n + ' ' + cur.active;
  }

  function mount() {
    if (document.getElementById('tm-ship-est')) return true;
    var anchor = document.querySelector('.cart-recap__checkout');
    var container = anchor ? anchor.parentElement : document.querySelector('.cart-recap');
    if (!anchor || !container) return false;

    var box = document.createElement('div');
    box.id = 'tm-ship-est';
    var opts = COUNTRIES.map(function (c) { return '<option value="' + c[0] + '">' + c[1] + '</option>'; }).join('');
    box.innerHTML =
      '<div class="tm-ttl">🚚 Estimate shipping</div>'
      + '<select id="tm-se-country" aria-label="Country">' + opts + '</select>'
      + '<input id="tm-se-zip" type="text" placeholder="Postal / ZIP (optional)" autocomplete="postal-code">'
      + '<button type="button" class="tm-go" id="tm-se-go">Calculate shipping</button>'
      + '<div class="tm-res" id="tm-se-res"></div>'
      + '<div class="tm-note">Shown before checkout. Ships from Kobe, Japan · Tracked.</div>';
    container.insertBefore(box, anchor);

    document.getElementById('tm-se-go').addEventListener('click', function () {
      var cc = document.getElementById('tm-se-country').value;
      var zip = document.getElementById('tm-se-zip').value.trim();
      var res = document.getElementById('tm-se-res');
      var btn = this;
      if (!cc) { res.innerHTML = '<div class="tm-msg">Please select a country.</div>'; return; }
      btn.disabled = true; btn.textContent = 'Calculating…'; res.innerHTML = '';
      var qs = 'shipping_address[country]=' + encodeURIComponent(cc) + (zip ? '&shipping_address[zip]=' + encodeURIComponent(zip) : '');

      function showRates(rates) {
        if (!rates || !rates.length) { res.innerHTML = '<div class="tm-msg">No rates for this address. Try a postal code, or see exact cost at checkout.</div>'; return; }
        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        res.innerHTML = rates.map(function (rt) {
          return '<div class="tm-rate"><span>' + (rt.presentment_name || rt.name) + '</span><b>' + fmt(rt.price) + '</b></div>';
        }).join('');
      }
      function finish() { btn.disabled = false; btn.textContent = 'Calculate shipping'; }
      function poll(tries) {
        fetch('/cart/async_shipping_rates.json?' + qs, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.status === 200 ? r.json() : null; })
          .then(function (d) {
            if (d && d.shipping_rates) { showRates(d.shipping_rates); finish(); return; }
            if (tries >= 8) { res.innerHTML = '<div class="tm-msg">Taking longer than usual — exact cost shows at checkout.</div>'; finish(); return; }
            setTimeout(function () { poll(tries + 1); }, 700);
          })
          .catch(function () { res.innerHTML = '<div class="tm-msg">Could not load rates right now. Cost will show at checkout.</div>'; finish(); });
      }
      fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () { poll(0); })
        .catch(function () { poll(0); });
    });
    return true;
  }

  mount();
  document.addEventListener('DOMContentLoaded', mount);
  // Тема перерисовывает корзину после загрузки — следим и при необходимости вставляем блок заново.
  try {
    new MutationObserver(function () {
      if (!document.getElementById('tm-ship-est')) mount();
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();